import React from 'react';
import ReportCenter from './ReportCenter';

function MemberActivityMonitorPage() {
  return (
    <ReportCenter
      standaloneConfig={{
        businessReport: 'member-activity',
        eyebrow: 'Member Activity Monitor',
        title: 'Member Activity Monitor',
        breadcrumbLabel: 'Member Activity Monitor',
        description: 'Pantau kunjungan, renewal, risiko churn, dan engagement member tanpa membuka seluruh Analytics Center.',
      }}
    />
  );
}

export default MemberActivityMonitorPage;
